<template>
	<div
		class="flow-tab"
		:tabindex="tabindex"
		:type="type"
		:selected="selected"
		:style="tabStyle"
		@click="handleClick($event)"
	>
		<!-- @slot Contains Tab content <br/> E.g. Icon , p , h4 ... -->
		<slot />
	</div>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { CSSProperties } from "vue/types/jsx";

const TYPE = ["transparent", "filled"] as const;

export type TabType = typeof TYPE[number];

export default defineComponent({
	name: "Tab",
	props: {
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},

		selected: {
			type: Boolean,
			default: false
		},

		type: {
			type: String as PropType<TabType>,
			default: "transparent",
			validator(value: TabType) {
				return TYPE.includes(value);
			}
		},

		width: {
			type: String,
			default: null
		}
	},
	computed: {
		tabStyle(): CSSProperties {
			return {
				width: this.width,
				flex: this.width ? "unset" : "1 0 auto"
			};
		}
	},
	methods: {
		handleClick(e: MouseEvent) {
			e.stopPropagation();
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
div.flow-tab {
	padding: 12px;
	position: relative;
	outline: none;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	max-width: 250px;

	> * {
		font-weight: 300;
	}
	&:after {
		position: absolute;
		content: "";
		left: 50%;
		right: 50%;
		bottom: 0px;
		transition: left 0.3s, right 0.3s;

		border-radius: 2px;
		z-index: 2;
		height: 2px;
	}
	&[selected] {
		> * {
			font-weight: 500;
		}

		&:after {
			left: 0px;
			right: 0px;
		}
	}

	&:hover {
		&:after {
			left: 0px;
			right: 0px;
		}
	}

	&[type="filled"] {
		border-radius: 4px;
		overflow: hidden;
	}
}
$font-color: var(--dashboard-font);
$font-dark-color: var(--dashboard-font-dark);
$selected: var(--dashboard-primary);
$filled-color: var(--dashboard-element-light);
$filled-selected-color: var(--dashboard-element);
$hover: var(--gray-300);

div.flow-tab {
	> * {
		color: $font-color;
	}
	&[selected] {
		> * {
			color: $font-dark-color;
		}

		&:after {
			background-color: $selected;
			// border: 2px solid $selected;
		}
	}

	&:hover:not([selected]) {
		&:after {
			background-color: $hover;
		}
	}

	&[type="filled"] {
		background-color: $filled-color;

		&[selected] {
			background-color: $filled-selected-color;
		}
	}
}
</style>
